/**
 * Created by Administrador on 15/10/2025.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('reprintBackupService',reprintBackupService);

    reprintBackupService.$inject = ['$http', 'CONFIG','messageService'];

    function reprintBackupService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/eTicketBackups';


        var service = {
            getETicketById: getETicketById,
            getSearchWithoutTicketByPnr: getSearchWithoutTicketByPnr
        };

        return service;

        function getETicketById(id){
            return $http.get(urlBase + '/' + id)
                .then(function(response){
                    return (response.data) ? response.data : [];
                }, function(){
                    messageService.findError('');
                });
        }

        function getSearchWithoutTicketByPnr(code,page, size){
            return $http.get(urlBase + '/search-by-pnr/without-ticket?pnr=' + code +'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
